/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
export function messageDuplicateSuccess() {
  return `Your message was successfully duplicated.`;
}

export function messageDuplicateFailure() {
  return `We couldn't duplicate your message. Send us a message and we'll do our best to help out.`;
}
